
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFFFFF",
        "d": "M35.428,24.397c0-0.825-0.272-2.115-0.606-2.867l-2.061-4.636c-0.334-0.754-1.276-1.369-2.093-1.369H17.89\r\n\tc-0.817,0-1.759,0.615-2.091,1.371l-2.051,4.632c-0.331,0.754-0.604,2.046-0.604,2.869v12.128c0,0.824,0.668,1.499,1.485,1.499\r\n\th19.313c0.819,0,1.485-0.675,1.485-1.499V24.397z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFFFFF",
        "d": "M32.458,10.274c0-0.823-0.668-1.499-1.485-1.499H17.601c-0.817,0-1.485,0.676-1.485,1.499v1.501\r\n\tc0,0.824,0.668,1.502,1.485,1.502h13.372c0.817,0,1.485-0.678,1.485-1.502V10.274z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#B7C3D7",
        "d": "M28.733,28.158c0.762,0,1.38-0.617,1.38-1.38s-0.618-1.38-1.38-1.38h-2.013l3.185-3.639\r\n\tc0.511-0.566,0.466-1.438-0.1-1.947c-0.566-0.512-1.438-0.463-1.949,0.104l-3.528,3.852l-3.591-3.877\r\n\tc-0.52-0.561-1.391-0.568-1.95-0.051c-0.56,0.517-0.595,1.445-0.079,2.005l3.209,3.554h-1.842c-0.762,0-1.379,0.617-1.379,1.38\r\n\ts0.617,1.38,1.379,1.38h2.791v1.569h-2.791c-0.762,0-1.379,0.618-1.379,1.38s0.617,1.38,1.379,1.38h2.791v1.138\r\n\tc0,0.85,0.688,1.539,1.539,1.539c0.85,0,1.538-0.689,1.538-1.539v-1.138h2.79c0.762,0,1.38-0.618,1.38-1.38s-0.618-1.38-1.38-1.38\r\n\th-2.79v-1.569H28.733z"
      }
    }
  ]
})
    }
  